// Keep failed session creation visible beside the draft. Only an explicit
// user action starts a new intent; ordinary retries retain idempotency.
export default function ComposerSubmitError({ error, busy, onNewDraft }) {
  if (!error) return null;
  return (
    <div role="alert" className="rounded-lg border border-apolo-error/30 bg-apolo-error/5 px-3 py-2 text-xs text-apolo-error">
      <p>{error.error || 'Não foi possível criar o chat. Seu rascunho foi preservado.'}</p>
      {error.status === 409 && <>
        <p className="mt-1">O envio anterior já foi aceito. Você pode iniciar outro chat mantendo este texto e os anexos.</p>
        <button type="button" disabled={busy} onClick={onNewDraft} className="mt-2 rounded border border-current px-2 py-1 font-medium disabled:opacity-50">
          Novo rascunho com este texto
        </button>
      </>}
    </div>
  );
}
